import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AlertCircle, Loader2 } from "lucide-react";
import { useState } from "react";

import { ErroApi } from "@/api/client";
import { useLogin } from "@/api/sessao";
import soapLogo from "@/assets/soap-logo.png";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login.mutate({ email, senha }, { onSuccess: () => navigate({ to: "/loja", replace: true }) });
  };

  const erro =
    login.error instanceof ErroApi
      ? login.error.mensagem
      : login.error
        ? "Não foi possível entrar. Tente novamente."
        : null;

  return (
    <div
      className="flex min-h-screen w-full items-center justify-center px-4"
      style={{ backgroundColor: "#0a0a0a" }}
    >
      <div className="w-full max-w-sm">
        <div className="mb-10 flex flex-col items-center gap-2">
          <img src={soapLogo} alt="SOAP" className="h-24 w-auto" />
          <span
            className="text-sm font-bold uppercase tracking-[0.28em]"
            style={{ color: "#FF5A00" }}
          >
            Flow
          </span>
        </div>

        <form
          onSubmit={onSubmit}
          className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur"
        >
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-white/80">
                E-mail
              </Label>
              <Input
                id="email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@empresa.com"
                className="border-white/15 bg-black/40 text-white placeholder:text-white/30"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="senha" className="text-white/80">
                Senha
              </Label>
              <Input
                id="senha"
                type="password"
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                className="border-white/15 bg-black/40 text-white placeholder:text-white/30"
                required
              />
            </div>

            {erro && (
              <div
                role="alert"
                className="flex items-start gap-2 rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-300"
              >
                <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
                {erro}
              </div>
            )}

            <Button
              type="submit"
              disabled={login.isPending}
              className="w-full font-semibold text-white hover:opacity-90 disabled:opacity-60"
              style={{ backgroundColor: "#FF5A00" }}
            >
              {login.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Entrar
            </Button>
          </div>
        </form>

        <p className="mt-6 text-center text-xs text-white/40">SOAP Flow · Gestão de produção</p>
      </div>
    </div>
  );
}
